import { createContext, useContext, type ReactNode } from 'react';

export type FileUploadTarget = {
	url: string;
	fields: Record<string, string>;
	uploadId: string;
	fileName: string;
};

// Each app supplies its own calls: registrants upload under their registration,
// admins under the event. Keeping tRPC out of here keeps this package agnostic
// of which router a surface talks to.
export type FileQuestionHandlers = {
	requestUpload: (request: { formFieldId: string; fileName: string; size: number }) => Promise<FileUploadTarget>;
	getAttachmentUrl: (formFieldId: string) => Promise<string>;
	getAnswerUrl?: (uploadId: string) => Promise<string>;
	// Edit forms only send answers that are present, so clearing one there would
	// look saved and change nothing. Those surfaces offer Replace only.
	canRemove?: boolean;
};

const FileQuestionContext = createContext<FileQuestionHandlers | null>(null);

export function FileQuestionProvider({ handlers, children }: { handlers: FileQuestionHandlers; children: ReactNode }) {
	return <FileQuestionContext.Provider value={handlers}>{children}</FileQuestionContext.Provider>;
}

export function useFileQuestionHandlers(): FileQuestionHandlers | null {
	return useContext(FileQuestionContext);
}
